export const FETCH_CATEGORIES = "fetchCategories";
export const FETCH_NEW_PRODUCTS = "fetchNewProduct";
export const FETCH_HOT_PRODUCTS = "fetchHotProduct";

export const FETCH_NEWS = "fetchNews";
export const FETCH_NEWS_DETAIL = "fetchNewsDetail";
export const FETCH_NEWS_RELATES = "fetchNewsRelates";
export const RESET_NEWS_STATE = "resetNewsState";
export const FETCH_LATEST_NEWS = "fetchLatestNews";
export const FETCH_SUPPORTS = "fetchSupports";
export const FETCH_SERVICES = "fetchServices";
export const FETCH_NEWS_BY_CATEGORY = "fetchNewsByCategory";

export const FETCH_PAGE = "fetchPage";
export const RESET_PAGE_STATE= "resetPage";

export const FETCH_PRODUCTS = "fetchProducts";
export const FETCH_PRODUCTS_BY_CATEGORY = "fetchProductsByCategory";
export const FETCH_PRODUCT_DETAIL = "fetchProductDetail";
export const SEARCH_PRODUCTS = "searchProducts";

